import type { ReactNode } from "react";

export interface FormStepProps {
	stepNumber?: number;
	title?: string;
	subtitle?: string;
	error?: string;
	children?: ReactNode;
}

const FormStep = ({
	children,
	error,
	stepNumber,
	title,
	subtitle
}: FormStepProps) => {
	return (
		<div
			className={[
				"rounded-xl border bg-subtle shadow-sm transition-colors",
				error ? "border-red-400/60" : "border-border"
			].join(" ")}
		>
			{error && (
				<div className="relative">
					<span
						role="alert"
						className="absolute -top-2.5 right-3 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-medium"
					>
						{error}
					</span>
				</div>
			)}

			<div className="p-6">
				{title && (
					<div className="mb-4">
						<label
							role="heading"
							aria-level={3}
							className="font-heading text-lg font-medium text-foreground"
						>
							{title}
						</label>
						{subtitle && (
							<p className="text-[13px] text-muted-foreground mt-1">
								{subtitle}
							</p>
						)}
					</div>
				)}

				{children}
			</div>
		</div>
	);
};

export default FormStep;
